import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sekondsToTime'
})
export class SekondsToTimePipe implements PipeTransform {

 transform(value: number | null | undefined): string {
    if (value == null) return '00:00:00';

    const hours = Math.floor(value / 3600);
    const minutes = Math.floor((value % 3600) / 60);
    const seconds = value % 60;

    return [
      hours.toString().padStart(2, '0'),
      minutes.toString().padStart(2, '0'),
      seconds.toString().padStart(2, '0')
    ].join(':');
  }

}
